module.exports = __webpack_public_path__ + "media/images/training-plan_hero-image@2x-c2bcc1edbf1bd8a531cef8d72149f2f7.jpg";